import { useSetAtom } from 'jotai';
import ShareIcon from 'icon/arrow_turn_up_right.svg';
import { $SharePanel } from '~/model';
import cls from 'classnames';
import { EClickPosition } from '~/utils/click-position';

import './style.scss';

interface IShare {
  className?: string;
}

export const Share = (prop: IShare) => {
  const { className } = prop;
  const setSharePanel = useSetAtom($SharePanel);

  const handleClick = (): void => {
    window.Tea('wap_click', {
      current_position: EClickPosition.TOP_BAR_SHARE,
      is_cta: 0,
    });
    setSharePanel(true);
  };

  return (
    <div className={cls(className, 'share-container')} onClick={handleClick}>
      <ShareIcon className="share-icon" />
    </div>
  );
};
